import { Typography } from '@pwskills/rachnaui';
import React from 'react';

const Loader = () => {
  return (
    <div className="relative w-[90%] h-full border border-[#FAB9AC] border-b-0 rounded-t-2xl shadow-lg m-auto">
      <div
        className="absolute w-full h-full inset-0 pointer-events-none z-0 rounded-t-2xl"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(0,0,0,0.1) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(0,0,0,0.1) 1px, transparent 1px)
            `,
          backgroundSize: '50px 50px',
          opacity: 0.5,
        }}
      />
      <div className="relative w-full h-full flex flex-col gap-10 justify-center items-center bg-gradient-to-b from-white  to-transparent z-10 rounded-t-2xl ">
        <div className="relative w-[20%] h-[20%] z-10">
          <img
            src="/images/accountImage/leadform/feedback_form.gif"
            alt="success"
            className="w-full h-full object-contain"
          />
        </div>
        <div className="flex flex-col justify-center items-center gap-2 mb-20">
          <Typography
            variant="semi-bold"
            component="h4"
            className="text-gray-800 text-center leading-8"
          >
            Thank you for reaching out!
          </Typography>
          <p className="max-w-[400px] text-gray-800 text-center font-nunito text-[18px] font-light leading-7">
            Our team will contact you super fast to resolve your queries 🚀
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
